export function noDataCondition(values) {
  const interval = Number(values.expected_interval_seconds);
  const missed = Number(values.missed_intervals);
  const duration = interval * missed;
  if (
    !Number.isInteger(interval) ||
    interval < 1 ||
    !Number.isInteger(missed) ||
    missed < 1 ||
    missed > 100 ||
    duration > 2592000
  ) {
    throw new Error(
      'بازه ارسال و تعداد بازه‌های انتظار را درست وارد کنید (حداکثر مهلت: ۳۰ روز).',
    );
  }
  return {
    duration_seconds: duration,
    expected_interval_seconds: interval,
    missed_intervals: missed,
    ...(values.metric_name ? { metric_name: values.metric_name } : {}),
  };
}
